import React, { Component } from 'react'
import { Container } from 'components/layout/Grid/'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import MainLayout from 'components/MainLayout'
import { hasAccess } from 'utils/hasAccess'
import { commonFunctions } from 'utils/CommonFunctions'
import { headerTitleName } from 'utils/headerTitleName'
import { getReports } from 'actions/reports'
import { modalShow, modalHide } from 'actions/modals'

class Reports extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    getReports: PropTypes.func.isRequired,
    reports: PropTypes.object.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,

  }
  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Reports', this.props.history)
    this.props.getReports(this.props.currentUser.EmployeeId)
  }
  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Reports'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const { routes, currentUser } = this.props
    const backToAdminCentreText = `${this.props.selectedPartner.Name}: Reports`
    const sidebar = (currentUser.IsAdmin && this.props.location.pathname.indexOf('admin/') > -1) ? 'partnerAdmin' : 'partnerSideBar'
    return (
      <div>
        <MainLayout
          bannerNavProps={{ ...this.bannerProps() }}
          currentUser={this.props.currentUser}
          partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
          sidebarType={sidebar}
          modalHide={this.props.modalHide}
          modalShow={this.props.modalShow}
        >
          <Container>
            {routes.map((route, i) => (
              <RouteWithSubRoutes
                key={i}
                {...route}
                backToAdminCentreText={backToAdminCentreText}
                currentUser={currentUser}
                dispatch={this.props.dispatch}
                getReports={this.props.getReports}
                reports={this.props.reports}
                setErrorMessage={this.props.setErrorMessage}
              />
            ))}

          </Container>
        </MainLayout>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  reports: state.reports,
  currentReportUrl: state.currentReportUrl,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getReports: (employeeId) => { dispatch(getReports(employeeId)) },
    modalShow: (id) => { dispatch(modalShow(id)) },
    modalHide: (id) => { dispatch(modalHide(id)) },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports))



// WEBPACK FOOTER //
// ./src/containers/Reports.js